const degreesToRadians = (degrees:number) => {
    return (degrees * Math.PI) / 180;
};

interface ICenter {
    lat: number,
    lng: number
}

export const distanceInMiBetweenEarthCoordinates = (lat1Init: number, lon1: number, center:ICenter) => {
    const earthRadiusMi = 3959;
    const lat2Init = center.lat;
    const lon2 = center.lng;

    const dLat = degreesToRadians(lat2Init - lat1Init);
    const dLon = degreesToRadians(lon2 - lon1);

    const lat1 = degreesToRadians(lat1Init);
    const lat2 = degreesToRadians(lat2Init);

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2) *
        Math.cos(lat1) *
        Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return earthRadiusMi * c;
};
